import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgcCookieConsentService, NgcInitializationErrorEvent, NgcInitializingEvent, NgcNoCookieLawEvent, NgcStatusChangeEvent } from 'ngx-cookieconsent';
import { Subscription }   from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  private popupOpenSubscription!: Subscription;
  private popupCloseSubscription!: Subscription;
  private initializingSubscription!: Subscription;
  private initializedSubscription!: Subscription;
  private initializationErrorSubscription!: Subscription;
  private statusChangeSubscription!: Subscription;
  private revokeChoiceSubscription!: Subscription;
  private noCookieLawSubscription!: Subscription;
  private insuadvisorCookiesInfo = {
    status: ''
  };

  constructor(private cookieService: NgcCookieConsentService,
              private translateService: TranslateService,
              private ccService: NgcCookieConsentService) {
  }

  ngOnInit(): void {
    this.popupOpenSubscription = this.cookieService.popupOpen$.subscribe(
      () => {
        this.saveCookiesConfig();
      });
    this.popupCloseSubscription = this.cookieService.popupClose$.subscribe(
      () => {
      });
    this.initializingSubscription = this.cookieService.initializing$.subscribe(
      (event: NgcInitializingEvent) => {
        this.insuadvisorCookiesInfo['status'] = event.status;
        this.saveCookiesConfig();
      });
    this.initializedSubscription = this.cookieService.initialized$.subscribe(
      () => {
      });
    this.initializationErrorSubscription = this.cookieService.initializationError$.subscribe(
      (event: NgcInitializationErrorEvent) => {
        this.insuadvisorCookiesInfo['status'] = event.error.message;
        this.saveCookiesConfig();
      });
    this.statusChangeSubscription = this.cookieService.statusChange$.subscribe(
      (event: NgcStatusChangeEvent) => {
        this.insuadvisorCookiesInfo['status'] = event.status;
        this.saveCookiesConfig();
      });
    this.revokeChoiceSubscription = this.cookieService.revokeChoice$.subscribe(
      () => {
      });
    this.noCookieLawSubscription = this.cookieService.noCookieLaw$.subscribe(
      (event: NgcNoCookieLawEvent) => {
        this.insuadvisorCookiesInfo['status'] = event.country;
        this.saveCookiesConfig();
      });
    this.translateService.addLangs(['en', 'es']);
    this.translateService.setDefaultLang('es');
    const browserLang = 'es';
    this.translateService.use(browserLang);
    this.translateService
      .get(['cookie.header', 'cookie.message', 'cookie.dismiss', 'cookie.allow', 'cookie.deny', 'cookie.link', 'cookie.policy'])
      .subscribe(data => {
        const ccConfig = this.ccService.getConfig();
        ccConfig.content = this.ccService.getConfig().content || {} ;
        ccConfig.content.allow = data['cookie.allow'];
        ccConfig.content.deny = data['cookie.deny'];
        this.ccService.destroy();
        this.ccService.init(this.ccService.getConfig());
      });
  }

  private saveCookiesConfig() {
    sessionStorage.setItem('insuadvisor_cookies', JSON.stringify(this.insuadvisorCookiesInfo));
  }

  ngOnDestroy(): void {
    this.popupOpenSubscription.unsubscribe();
    this.popupCloseSubscription.unsubscribe();
    this.initializingSubscription.unsubscribe();
    this.initializedSubscription.unsubscribe();
    this.initializationErrorSubscription.unsubscribe();
    this.statusChangeSubscription.unsubscribe();
    this.revokeChoiceSubscription.unsubscribe();
    this.noCookieLawSubscription.unsubscribe();
    sessionStorage.removeItem('insuadvisor_cookies');
  }

}
